import { render, staticRenderFns } from "./WorkBreakdownStructureWBSElement.vue?vue&type=template&id=7989a07d&scoped=true&"
import script from "./WorkBreakdownStructureWBSElement.vue?vue&type=script&lang=js&"
export * from "./WorkBreakdownStructureWBSElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7989a07d",
  null
  
)

export default component.exports